export { SORT_TYPES } from './sortTypes';

export const GIVING_BY_FUND_COLUMNS = [
  { id: 'name', label: 'Fund', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'total_raised', label: 'Total Raised', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'donor_count', label: 'Donors', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'gift_count', label: 'Gifts', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'campaign_count', label: 'Campaigns', defaultVisible: true, sortable: true, sortType: 'number' },
];

export const getDefaultVisibleColumns = () =>
  GIVING_BY_FUND_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  GIVING_BY_FUND_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
